export function BarMark({ size = 24 }: { size?: number }) {
  const bars: Array<[number, string]> = [
    [0.5, '--lab-teal'],
    [0.8, '--brand'],
    [0.62, '--amber'],
    [1, '--lab-purple']
  ];
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'flex-end',
        gap: 2.5,
        height: size,
        width: size,
        flexShrink: 0
      }}
    >
      {bars.map(([h, c], i) => (
        <span
          key={i}
          style={{
            flex: 1,
            height: `${h * 100}%`,
            background: `var(${c})`,
            borderRadius: 2
          }}
        />
      ))}
    </div>
  );
}
